import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import '../styles/font_icons.scss';
import '../styles/fonts.scss';

const FontIcon = ({className, size, type = 'add'}) => {
  return <div className={cx('sh-iconset', `${size ? size : ''}`, `sh-iconset-${type}`, className)} />;
};

FontIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
};

export default FontIcon;
